import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createSubTraitAPI, deleteSubTraitAPI, getSubTraitByIdAPI, getSubTraitCarouselListingApi, getSubTraitsListingAPI, updateSubTraitAPI } from "../../redux/apis/subtraits";
import { getUnitListingAPI } from "../../redux/apis/traits";
import { createProductUnitsAPI } from "../../redux/apis/traits";
import { deleteProductUnitsAPI } from "../../redux/apis/traits";


export const getSubTraitListing = createAsyncThunk(
  "traits/getSubTraits",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getSubTraitsListingAPI(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);


export const getSubTraitCarouselListing = createAsyncThunk(
  "traits/getSubTraitCarouselListing",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getSubTraitCarouselListingApi(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const addSubTrait = createAsyncThunk(
  "traits/addSubTrait",
  async (data, { rejectWithValue }) => {
    try {
      const res = await createSubTraitAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteSubTrait = createAsyncThunk(
  "subtraits/deleteSubTraits",
  async ({ slug, platform }, { rejectWithValue }) => {
    try {
      const res = await deleteSubTraitAPI(slug, platform);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getSubTraitById = createAsyncThunk(
  "subTrait/getSubTraitId",
  async ({ slug, data }, { rejectWithValue }) => {
    try {
      const res = await getSubTraitByIdAPI(slug, data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSubTrait = createAsyncThunk(
  "subTrait/updateSubTrait",
  async ({ data, slug, platform }, { rejectWithValue }) => {
    try {
      const res = await updateSubTraitAPI(data, slug, platform);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getUnitListing = createAsyncThunk(
  "products/getProductUnits",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getUnitListingAPI(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const addProductUnit = createAsyncThunk(
  "products/addProductUnit",
  async (data, { rejectWithValue }) => {
    try {
      const res = await createProductUnitsAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);


export const deleteProductUnit = createAsyncThunk(
  "products/deleteProductUnit",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteProductUnitsAPI(id);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const subTraitSlice = createSlice({
  name: "subtraits",
  initialState: {
    subtraits: [],
    subTraitDetails: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSubTraitListing.fulfilled, (state, action) => {
      state.loading = false;
      state.subtraits = action.payload;
      state.error = null;
      state.subTraitDetails = {};
    });

    builder.addCase(getSubTraitListing.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Extra reducer for the pending action of fetchStores
    builder.addCase(getSubTraitListing.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addSubTrait.fulfilled, (state, action) => {
      state.loading = false;
      state.addedSubTrait = action.payload; // Add the new subTrait to the traits list
      state.error = null;
    });

    builder.addCase(addSubTrait.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(addSubTrait.pending, (state) => {
      state.loading = true;
    });


    builder.addCase(getSubTraitById.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getSubTraitById.fulfilled, (state, action) => {
      state.loading = false;
      state.subTraitDetails = action.payload;
      state.error = null;
    });

    builder.addCase(getSubTraitById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder
      .addCase(updateSubTrait.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSubTrait.fulfilled, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSubTrait.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder.addCase(getSubTraitCarouselListing.fulfilled, (state, action) => {
      state.loading = false;
      // state.subtraits = action.payload;
      state.error = null;
      // state.subTraitDetails = {};
    });

    builder.addCase(getSubTraitCarouselListing.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Extra reducer for the pending action of fetchStores
    builder.addCase(getSubTraitCarouselListing.pending, (state) => {
      state.loading = true;
    });
  },
});

export const { } = subTraitSlice.actions;

export default subTraitSlice.reducer;
